<app-context-menu-heading>Sorting options:</app-context-menu-heading>

@if ((withAdvancedSearch && advancedSearchApplied) || withScore) {
  <app-context-menu-item
    [withCheckOption]="true"
    title="Relevance"
    [active]="state.sortBy === 'score'"
    [sortable]="true"
    [reversed]="state.sortOrder === 'desc'"
    (execute)="sort('score')"
    />
}

<app-context-menu-item
  [withCheckOption]="true"
  title="Subject"
  [active]="state.sortBy === 'title'"
  [sortable]="true"
  [reversed]="state.sortOrder === 'desc'"
  (execute)="sort('title')"
  />

  <app-context-menu-item
    [withCheckOption]="true"
    title="Date"
    [active]="state.sortBy === 'date'"
    [sortable]="true"
    [reversed]="state.sortOrder === 'desc'"
    (execute)="sort('date')"
    />

    <app-context-menu-item
      [withCheckOption]="true"
      title="Attachments"
      [active]="state.sortBy === 'attachmentsCount'"
      [sortable]="true"
      [reversed]="state.sortOrder === 'desc'"
      (execute)="sort('attachmentsCount')"
      />

      @if (withToSort) {
        <app-context-menu-item
          [withCheckOption]="true"
          title="To"
          [active]="state.sortBy === 'sentto'"
          [sortable]="true"
          [reversed]="state.sortOrder === 'desc'"
          (execute)="sort('sentto')"
          />
        }

        @if (withFromSort) {
          <app-context-menu-item
            [withCheckOption]="true"
            title="From"
            [active]="state.sortBy === 'sentfrom'"
            [sortable]="true"
            [reversed]="state.sortOrder === 'desc'"
            (execute)="sort('sentfrom')"
            />
          }

          <app-context-menu-divider />

          <app-context-menu-item
            [withCheckOption]="true"
            title="Pinned on top"
            [active]="state.pinnedOnTop"
            (execute)="pinnedOnTop()"
            />

@if (virtualFolder() !== 'flagged') {
            <app-context-menu-item
              [withCheckOption]="true"
              title="Flagged on top"
              [active]="state.flaggedOnTop"
              (execute)="flaggedOnTop()"
              />
}

              @if (withThreadedView) {
                <app-context-menu-item
                  [withCheckOption]="true"
                  title="Conversation view"
                  [active]="state.threadedView"
                  (execute)="threadedView()"
                  />
              }

                <app-context-menu-heading>Filters:</app-context-menu-heading>

                <app-stitch-type-context-menu-item
                  [withCheckOption]="true"
                  title="Stitch"
                  [state]="state.stitchedWith"
                  (onSelect)="stitch($event)"
                  />

                  <app-context-menu-divider />

                  <app-context-menu-item
                    [withCheckOption]="true"
                    title="Flagged"
                    [active]="state.flagged"
                    (execute)="flag()"
                    />

                    @if (withUnreadFilter) {
                      <app-context-menu-item
                        [withCheckOption]="true"
                        title="Unread"
                        [active]="state.unread"
                        (execute)="unread()"
                        />
                    }

                    <app-context-menu-item
                      [withCheckOption]="true"
                      title="Pinned"
                      [active]="state.pinned"
                      (execute)="pin()"
                      />

                      @if (withScore) {
                        <!-- KP alone offers this: it ranks by relevance, so nothing else there narrows to today. -->
                        <app-context-menu-item
                          [withCheckOption]="true"
                          title="Today"
                          [active]="state.today"
                          (execute)="today()"
                          />
                      }

                        <app-context-menu-item
                          [withCheckOption]="true"
                          [active]="!!(state.from || state.to)"
                          title="Selected date"
                          >
                          <div class="date">
                            <div class="date-buttons">
                              <div
                                class="date-buttons-item"
                                [class.selected]="dateButtonSelected === 'from'"
                                [class.active]="innerFromDate?.value"
                                (click)="dateButtonSelected = 'from'"
                                >
                                <app-icon class="date-buttons-item-icon" name="sapphire-events" [size]="16" />
                                <span class="date-buttons-item-text">{{ innerFromDate?.value ? (innerFromDate?.value | dateFormat : 'date') : 'After'}}</span>
                              </div>
                              <div
                                class="date-buttons-item"
                                [class.selected]="dateButtonSelected === 'to'"
                                [class.active]="innerToDate?.value"
                                (click)="dateButtonSelected = 'to'"
                                >
                                <app-icon class="date-buttons-item-icon" name="sapphire-events" [size]="16" />
                                <span class="date-buttons-item-text">{{ innerToDate?.value ? (innerToDate?.value | dateFormat : 'date') : 'Before'}}</span>
                              </div>
                            </div>

                            <app-date-picker-2
                              [flush]="true"
                              [inputFormControl]="dateButtonSelected === 'from' ? innerFromDate : innerToDate"
                              [collapseable]="false"
                              [maxDate]="dateButtonSelected === 'from' && innerToDate?.value"
                              [minDate]="dateButtonSelected === 'to' && innerFromDate?.value"
                              [highlightRange]="true"
                              />

                            @if (!!(state.from || state.to)) {
                              <div class="flex justify-end pt-2">
                                <app-button2 appearance="primary-text" size="s" (click)="clearSelectedDate()">Clear</app-button2>
                              </div>
                            }
                            </div>
                          </app-context-menu-item>
